module.exports = __webpack_public_path__ + "media/images/vp/icon.gifts-cbc311f7f453ab7fab0444f60abc454c.svg";